<template>
  <div class="px-2.5 w-full z-0 bg-gray-500">
      <slot />
  </div>
</template>